import { ResetFiltersButton } from "@/controls/buttons/ResetFiltersButton";
import { Box } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import type { Moment } from "moment";
import { ExcelButton } from "@/controls/buttons/ExcelButton";
import { PdfButton } from "@/controls/buttons/PdfButton";

interface Props {
	start: Moment;
	end: Moment;
	onStartChange: (date: Moment | null) => void;
	onEndChange: (date: Moment | null) => void;
	onExportExcel: () => void;
	onExportPdf: () => void;
	canExportPdf: boolean;
	exportingPdf: boolean;
	onReset: () => void;
	canReset: boolean;
}

export const NewRollsToolbar = ({
	start,
	end,
	onStartChange,
	onEndChange,
	onExportExcel,
	onExportPdf,
	canExportPdf,
	exportingPdf,
	onReset,
	canReset,
}: Props) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				px: 1.5,
				py: 0.75,
				flexWrap: "wrap",
			}}
		>
			<Box sx={{ minWidth: 150, maxWidth: 170 }}>
				<DatePicker
					label="Start"
					format="MM/DD/YYYY"
					value={start}
					maxDate={end}
					onChange={onStartChange}
					slotProps={{ textField: { size: "small", fullWidth: true } }}
				/>
			</Box>
			<Box sx={{ minWidth: 150, maxWidth: 170 }}>
				<DatePicker
					label="Close"
					format="MM/DD/YYYY"
					value={end}
					minDate={start}
					onChange={onEndChange}
					slotProps={{ textField: { size: "small", fullWidth: true } }}
				/>
			</Box>

			<ResetFiltersButton onClick={onReset} disabled={!canReset} />

			<Box sx={{ flexGrow: 1, minWidth: 8 }} />

			<Box sx={{ display: "flex", gap: 1 }}>
				<ExcelButton handleExportToExcel={onExportExcel} />
				<PdfButton
					handleExportToPdf={onExportPdf}
					disabled={!canExportPdf}
					loading={exportingPdf}
				/>
			</Box>
		</Box>
	);
};
